/**
 * Comformidable Nieuwsbrief Popup
 * - Slaat e-mail op als Shopify klant via /contact (accepts_marketing=true)
 * - Toont kortingscode na aanmelding, zonder page reload
 * - Exit-intent (desktop) + timer (mobiel), 1x per bezoeker, 30d cooldown
 */
(function () {
  'use strict';

  const overlay = document.getElementById('cf-popup-overlay');
  if (!overlay) return;

  // ─── Config ───────────────────────────────────────────────
  const COOLDOWN_DAYS  = parseInt(overlay.dataset.cooldownDays, 10) || 30;
  const DELAY_DESKTOP  = parseInt(overlay.dataset.delayDesktop, 10) || 0;
  const DELAY_MOBILE   = parseInt(overlay.dataset.delayMobile, 10) || 8;
  const COOKIE_SEEN    = 'cf_popup_seen';
  const COOKIE_DONE    = 'cf_popup_subscribed';
  const isMobile       = window.matchMedia('(max-width: 600px)').matches;
  const isExcludedPage = /\/(checkout|cart)(\/|$|\?)/.test(window.location.pathname);

  // ─── Cookie helpers ───────────────────────────────────────
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    return document.cookie.split('; ').reduce((acc, c) => {
      const [k, v] = c.split('=');
      return k === name ? decodeURIComponent(v) : acc;
    }, '');
  }

  // ─── Tracking (anoniem, faalt stil; toegevoegd 22-09-2026) ─
  const API_BASE = 'https://dr-commerce-dashboard.vercel.app';
  function sessionId() {
    try {
      const k = 'cf_ps';
      let s = sessionStorage.getItem(k);
      if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem(k, s); }
      return s;
    } catch (e) { return 'anon'; }
  }
  function track(type) {
    try {
      fetch(API_BASE + '/api/popup-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_type: type, session_id: sessionId() }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }
  let subscribed = false;

  // ─── Wanneer tonen? ───────────────────────────────────────
  function shouldShow() {
    if (isExcludedPage) return false;
    if (getCookie(COOKIE_DONE)) return false; // al aangemeld: nooit meer
    if (getCookie(COOKIE_SEEN)) return false; // recent gezien: cooldown
    return true;
  }

  // ─── Open / sluit ─────────────────────────────────────────
  let isOpen = false;

  // ─── Wacht op de cookiebanner (28-10-2026) ────────────────
  // Nooit tegelijk met de cookiebanner: eerst moet de bezoeker kiezen, daarna
  // nog minstens NA_BANNER_MS. Exit-intent tijdens een open banner slaat over.
  const NA_BANNER_MS = 20000;
  let bannerDichtSinds = Date.now();
  function bannerOpen() {
    const t = document.getElementById('tst');
    if (t && t.hasAttribute('data-open')) return true;
    try { return !!(window.Toestemming && window.Toestemming.isOpen && window.Toestemming.isOpen()); } catch (e) { return false; }
  }

  function openPopup(viaExit) {
    if (isOpen || !shouldShow()) return;
    if (bannerOpen()) {
      bannerDichtSinds = 0;
      if (viaExit !== true) setTimeout(openPopup, 3000);
      return;
    }
    if (!bannerDichtSinds) bannerDichtSinds = Date.now();
    const wacht = NA_BANNER_MS - (Date.now() - bannerDichtSinds);
    if (wacht > 0) {
      if (viaExit !== true) setTimeout(openPopup, wacht);
      return;
    }
    isOpen = true;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setCookie(COOKIE_SEEN, '1', COOLDOWN_DAYS);
    track('shown');
    const input = document.getElementById('cf-popup-email');
    if (input && !isMobile) setTimeout(() => input.focus(), 350);
  }
  function closePopup() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (!subscribed) track('dismissed');
  }

  // ─── Triggers ─────────────────────────────────────────────
  function armTriggers() {
    if (!shouldShow()) return;

    if (isMobile) {
      // Mobiel: timer
      setTimeout(openPopup, DELAY_MOBILE * 1000);
    } else {
      // Desktop: exit-intent + fallback timer (30s)
      const onMouseOut = (e) => {
        if (e.clientY <= 0 && !e.relatedTarget) {
          openPopup(true);
          document.removeEventListener('mouseout', onMouseOut);
        }
      };
      document.addEventListener('mouseout', onMouseOut);

      if (DELAY_DESKTOP > 0) {
        setTimeout(openPopup, DELAY_DESKTOP * 1000);
      } else {
        // Fallback: als ze 45s blijven zonder exit-intent, toch tonen
        setTimeout(openPopup, 45000);
      }
    }
  }

  // ─── E-mail valideren ─────────────────────────────────────
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ─── Stap wisselen ────────────────────────────────────────
  function showSuccess() {
    const formStep = document.getElementById('cf-popup-step-form');
    const successStep = document.getElementById('cf-popup-step-success');
    if (formStep) formStep.hidden = true;
    if (successStep) successStep.hidden = false;
  }

  // ─── E-mail opslaan via Shopify customer form ─────────────
  function subscribeEmail(email) {
    const form = document.getElementById('cf-popup-customer-form');
    if (!form) return Promise.reject(new Error('no-form'));

    const formData = new FormData(form);
    formData.set('contact[email]', email);

    return fetch(form.action || '/contact', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json, text/html' }
    }).then((res) => {
      // Shopify /contact geeft meestal een redirect/200 terug.
      // We beschouwen elke niet-serverfout als succes (klant wordt aangemaakt).
      if (res.status >= 500) throw new Error('server');
      return true;
    });
  }

  // ─── Form submit afhandelen ───────────────────────────────
  const form = document.getElementById('cf-popup-customer-form');
  const submitBtn = document.getElementById('cf-popup-submit');
  const errorEl = document.getElementById('cf-popup-error');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = document.getElementById('cf-popup-email');
      const email = (input.value || '').trim();

      if (errorEl) { errorEl.classList.remove('is-visible'); errorEl.textContent = ''; }

      if (!isValidEmail(email)) {
        if (errorEl) {
          errorEl.textContent = window.cfPopupI18n?.invalidEmail || 'Vul een geldig e-mailadres in.';
          errorEl.classList.add('is-visible');
        }
        return;
      }

      if (submitBtn) submitBtn.classList.add('is-loading');

      subscribeEmail(email)
        .then(() => {
          subscribed = true;
          setCookie(COOKIE_DONE, '1', 365);
          track('subscribed');
          showSuccess();
        })
        .catch(() => {
          if (errorEl) {
            errorEl.textContent = window.cfPopupI18n?.errorGeneral || 'Er ging iets mis. Probeer het opnieuw.';
            errorEl.classList.add('is-visible');
          }
        })
        .finally(() => {
          if (submitBtn) submitBtn.classList.remove('is-loading');
        });
    });
  }

  // ─── Kopieer code ─────────────────────────────────────────
  const copyBtn = document.getElementById('cf-popup-copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      const code = copyBtn.dataset.code || '';
      const done = () => {
        copyBtn.classList.add('is-copied');
        const txt = copyBtn.querySelector('.cf-popup__copy-text');
        const orig = txt ? txt.textContent : '';
        if (txt) txt.textContent = window.cfPopupI18n?.copied || 'Gekopieerd!';
        setTimeout(() => {
          copyBtn.classList.remove('is-copied');
          if (txt) txt.textContent = orig;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        const tmp = document.createElement('textarea');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(tmp);
        done();
      }
    });
  }

  // ─── Sluit-knoppen ────────────────────────────────────────
  ['cf-popup-close', 'cf-popup-decline', 'cf-popup-continue'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('click', closePopup);
  });
  overlay.addEventListener('click', (e) => { if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });

  // ─── Start ────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armTriggers);
  } else {
    armTriggers();
  }

  // ─── Publieke API (voor testen) ───────────────────────────
  window.cfPopup = {
    open: () => { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); isOpen = true; },
    close: closePopup,
    reset: () => {
      document.cookie = COOKIE_SEEN + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      document.cookie = COOKIE_DONE + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      console.log('cf-popup cookies gewist. Herlaad de pagina.');
    }
  };
})();